import React from 'react';
import AccountGridBox from './accountGridBox';

export default function AccountDetailsCard({ accountDetails }) {
	return (
		<div className="bg-white px-4 py-2 mx-4 my-3 rounded-4">
			<div className="fs-4 font-medium text-black pb-3">Account Details</div>

			<div className="account-grid">
				<AccountGridBox
					label={'Account Name'}
					value={accountDetails?.account_name}
				/>
				<AccountGridBox
					label={'Category'}
					value={accountDetails.category}
				/>
				<AccountGridBox
					label={'Description'}
					value={accountDetails.description || '-'}
				/>
				<span></span>
				<AccountGridBox
					label={'Account Code'}
					value={accountDetails.account_code}
				/>
				<AccountGridBox
					label={'Parent Account'}
					value={accountDetails?.parent_account?.account_name || '-'}
				/>
				<AccountGridBox
					label={'Add to Watchlist'}
					value={accountDetails.is_watchlist ? 'Yes' : 'No'}
				/>
				<AccountGridBox
					label={'Created By'}
					value={accountDetails.created_by || ''}
				/>

				<AccountGridBox
					label={'Account Type'}
					value={accountDetails.account_type}
				/>

				<AccountGridBox
					label={'Status'}
					value={accountDetails.status === 0 ? 'Inactive' : 'Active'}
				/>
			</div>
		</div>
	);
}
